import { FilterDescriptor } from '@progress/kendo-data-query'
import { useAppSelector } from 'store'

import { SelectFilter } from '../SelectFilter'

export const ClientsCountriesFilter = ({
  filter,
  onFilterChange,
}: {
  filter: FilterDescriptor
  onFilterChange: (event: { nextFilter: FilterDescriptor }) => void
}): JSX.Element => {
  const countryDtos = useAppSelector((state) => state.identity.countries)

  const data = countryDtos.map((x) => ({ id: x.id, label: x.name, value: x.id }))

  return (
    <SelectFilter
      placeholder='Countries'
      filter={filter}
      onFilterChange={onFilterChange}
      data={data}
      style={{ width: 250 }}
    />
  )
}
